var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { Component, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
// import { useSelector } from 'react-redux';
import SmallTextBlock from './smalltextblock';
import styled, { css } from 'styled-components';
import { longreadDragEnd } from '../../../actions/longreadblocks';
import { getLongReadPosts, getLongReadPostsPaginated } from '../../../actions/getLongReadPosts';
import { updateLongReadPosition } from '../../../actions/updateLongReadPosition';
import { incrementLongReadPosition } from '../../../actions/incrementLongReadPosition';
import BottomTextEditor from '../longread/editor/texteditormobile';
import BottomImageEditor from '../longread/editor/imageeditormobile';
import UpdateEl from './editor/updateel';
import { useVotesCollection } from '../../../hooks/useVoteCollection';
import { VotesProvider, useVotesContext } from '../../../contexts/VotesContext';
import { setVoteEntityId } from '../../../actions/setVoteEntityId';
import { setVoteWinner } from '../../../actions/setVoteWinner';
import { VOTE_STATUS } from './postblocks/VoteBlock/votepostwithcollect';
import useCommonProps from '../../../hooks/useCommonProps';
import { getCurrentLongread } from "../../../reducers/longreadBlocks";
import { getAddLongread } from "../../../reducers/addLongReadPost";
import { getToggleLongReadPostUpdate } from "../../../reducers/toggleLongReadPostUpdate";
import { hasCourseRole, isStudentHomeWork } from '../../../utilites/hasCourseRole';
import { CourseLinkBlock } from "./postblocks/CourseBlock/courseLinkBlock";
import { HOME_WORK_STUDENT_SIGN } from './postblocks/CourseBlock/courseHomeWork';
import { updateLongReadPost } from '../../../actions/updateLongReadPost';
import { FlexBox, useToasts } from '@brg/ui';
import useLocalization from '../../../hooks/useLocalization';
import { useGeneralProps } from '../../../hooks/useGeneralProps';
import { HomeworkTitleBlock } from './postblocks/HomeworkTitleBlock/HomeworkTitleBlock';
import { getAdditionalInfoVal } from '../../../utilites/getAdditionalInfoVal';
import { SubmitHomeworkButton } from './postblocks/CourseBlock/SubmitHomeworkButton';
import { API, Endpoints, Lang } from '@brg/api';
import { useProfile } from '@brg/auth';
import InfiniteScroll from 'react-infinite-scroll-component';
import PostCommentProvider from '../comments/provider/CommentProvider';
import CommentViewController from '../comments';
import MeasureTemlate from './postblocks/MagazineBlock/MeasureTemlate';
var Bg = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var printType = _a.printType;
    return printType === 'magazine' && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      // scale: 0.76301496887;\n      // transform-origin: left top;\n  "], ["\n      // scale: 0.76301496887;\n      // transform-origin: left top;\n  "])));
});
export var Reorder = function (list, startIndex, endIndex) {
    var result = Array.from(list);
    var removed = result.splice(startIndex, 1)[0];
    result.splice(endIndex, 0, removed);
    return result;
};
// переписанный на func
function DndWrap(props) {
    var protectInfoComponent = props.protectInfoComponent, limitContentCount = props.limitContentCount, setLongreadStyle = props.setLongreadStyle;
    var _a = useState(false), isDragContinue = _a[0], setIsDragContinue = _a[1];
    var _b = useState((props === null || props === void 0 ? void 0 : props.includedCards) || []), includedCards = _b[0], setIncludedCards = _b[1];
    var dispatch = useDispatch();
    var _c = useLocalization(), t = _c.t, language = _c.language;
    var toasts = useToasts();
    var votesCollection = useVotesCollection();
    var _d = useCommonProps(), teamContexts = _d.teamContexts, currentSorting = _d.currentSorting, teamExtraFilter = _d.teamExtraFilter, setUpdateVoteTime = _d.setUpdateVoteTime, isPrint = _d.isPrint, printType = _d.printType, pagination = _d.pagination, onSetAnchors = _d.onSetAnchors, coverContent = _d.coverContent, longreadId = _d.longreadId, toggleMobileEditor = _d.toggleMobileEditor, role = _d.role, profileId = _d.profileId, isLMS = _d.isLMS, lastLongreadBlockLink = _d.lastLongreadBlockLink, onSetThemeAnchors = _d.onSetThemeAnchors, onOpenSetProjectsModal = _d.onOpenSetProjectsModal, sign = _d.sign, teamId = _d.teamId, isEditable = _d.isEditable, pagingLimit = _d.pagingLimit, projectId = _d.projectId, magazineContent = _d.magazineContent, lmsModuleInfo = _d.lmsModuleInfo;
    var generalProps = useGeneralProps();
    var votesAutoData = useVotesContext();
    var _e = React.useState(false), submitDisabled = _e[0], setSubmitDisabled = _e[1];
    var profile = useProfile();
    var _f = useState(pagingLimit), displayedBlocks = _f[0], setDisplayedBlocks = _f[1];
    var _g = useState(false), activeUploader = _g[0], setActiveUploader = _g[1];
    var _h = useState(1), currentPage = _h[0], setCurrentPage = _h[1];
    var _j = useState(false), isLoadingMore = _j[0], setIsLoadingMore = _j[1];
    var _k = useState([]), magazineBlocks = _k[0], setMagazineBlocks = _k[1];
    var handleSubmitHomework = function (_a) {
        var moduleProjectId = _a.moduleProjectId, themeLongreadId = _a.themeLongreadId, postId = _a.postId;
        if (submitDisabled)
            return;
        API.request()
            .endpoint(Endpoints.geograffee)
            .url('/api/LMS/SubmitHomeWork')
            .body({
            moduleProjectId: moduleProjectId || projectId || '',
            themeLongreadId: themeLongreadId || '',
            postId: postId || '',
            studentId: (profile === null || profile === void 0 ? void 0 : profile.accountId) || ''
        })
            .post()
            .send()
            .then(function (r) { return setTimeout(function () {
            dispatch(getLongReadPosts('', themeLongreadId));
        }, 1000); })
            .catch(function (error) { return console.error('Request failed', error); });
    };
    useEffect(function () {
        var _a;
        (_a = props.blocks) === null || _a === void 0 ? void 0 : _a.forEach(function (post) {
            var _a, _b;
            var submitted = (_b = (_a = post === null || post === void 0 ? void 0 : post.additionalInfo) === null || _a === void 0 ? void 0 : _a.find(function (i) { return i.name === 'is_submitted'; })) === null || _b === void 0 ? void 0 : _b.value;
            if (submitted)
                setSubmitDisabled(true);
        });
    }, [props.blocks]);
    var votesProps = useMemo(function () {
        var _a;
        return (__assign(__assign({}, props.votesContent), { voteCollectionData: (votesCollection === null || votesCollection === void 0 ? void 0 : votesCollection[0]) || [], updateVote: votesCollection === null || votesCollection === void 0 ? void 0 : votesCollection[1], entityId: (_a = votesCollection === null || votesCollection === void 0 ? void 0 : votesCollection[0]) === null || _a === void 0 ? void 0 : _a.entityId }));
    }, [votesCollection, props]);
    var isStageChange = useMemo(function () { var _a, _b; return !!((_b = (_a = votesAutoData === null || votesAutoData === void 0 ? void 0 : votesAutoData.voteData) === null || _a === void 0 ? void 0 : _a.Stages) === null || _b === void 0 ? void 0 : _b.length); }, [votesAutoData]);
    var isEndVote = useMemo(function () {
        var _a;
        return (votesProps === null || votesProps === void 0 ? void 0 : votesProps.voteCollectionData) &&
            ((_a = votesProps === null || votesProps === void 0 ? void 0 : votesProps.voteCollectionData) === null || _a === void 0 ? void 0 : _a.status) === VOTE_STATUS.end;
    }, [votesProps]);
    var hasStudentWork = useMemo(function () { var _a; return ((_a = props.blocks) === null || _a === void 0 ? void 0 : _a.some(function (p) { return isStudentHomeWork(p, profileId); })); }, [props.blocks, role]);
    var isNone = hasCourseRole('none', role);
    var isStudent = hasCourseRole('student', role);
    var isTeacher = hasCourseRole('teacher', role);
    //Сохранялка мобильной презентации
    useEffect(function () {
        if (props.isPresentation && window.innerWidth <= 940 && props.mobileEditorAction === 'savePresentation') {
            var coverPost = blocksSorted === null || blocksSorted === void 0 ? void 0 : blocksSorted.find(function (i) { return i.style === 'as_cover'; });
            dispatch(updateLongReadPost('', __assign(__assign({}, coverPost), { text: coverContent === null || coverContent === void 0 ? void 0 : coverContent.psTitleMob })));
        }
    }, [props, coverContent]);
    useEffect(function () {
        if ((votesAutoData === null || votesAutoData === void 0 ? void 0 : votesAutoData.needToStart) &&
            (votesAutoData === null || votesAutoData === void 0 ? void 0 : votesAutoData.setNeedToStart) &&
            setUpdateVoteTime) {
            votesAutoData.setNeedToStart(false);
            setUpdateVoteTime(new Date().getTime());
        }
    }, [
        votesAutoData === null || votesAutoData === void 0 ? void 0 : votesAutoData.needToStart,
        setUpdateVoteTime,
        votesAutoData === null || votesAutoData === void 0 ? void 0 : votesAutoData.setNeedToStart
    ]);
    var _l = useState(''), did = _l[0], setDid = _l[1];
    //todo объединить все переборы в один
    var uploadedHomeworksCount = useMemo(function () {
        return Array.isArray(props.blocks) && props.blocks.filter(function (block) {
            var _a;
            return ((_a = block.additionalInfo) === null || _a === void 0 ? void 0 : _a.find(function (i) { return i.name === 'hm_type'; })) &&
                (block.style !== 'homework_student' && block.style !== 'course_homework');
        }).length;
    }, [props.blocks]);
    var blocksSortedRaw = useMemo(function () {
        var _a;
        return props.isDragEnd ?
            props.blocks : (_a = __spreadArray([], props.blocks, true)) === null || _a === void 0 ? void 0 : _a.filter(function (block) {
            var _a, _b, _c, _d, _e, _f, _g;
            // на печати будут показываться не все блоки
            var printStyles = ['big', 'image', 'colored', 'normal', 'slider', 'two_pictures', 'projects', 'bibliography', 'image_sources'];
            if (isPrint)
                return printStyles.includes(block === null || block === void 0 ? void 0 : block.style);
            if (isLMS) {
                //показываем пост студента после отправки д/з
                if (isStudent && hasStudentWork && isStudentHomeWork(block, profileId)) {
                    return true;
                }
                //не показываем работы других студентов
                if (isStudent && !isStudentHomeWork(block, profileId) && ((_a = block === null || block === void 0 ? void 0 : block.additionalInfo) === null || _a === void 0 ? void 0 : _a.find(function (i) { return (i === null || i === void 0 ? void 0 : i.name) === 'student_id'; }))) {
                    return false;
                }
                //не показываем студентам блок создания нового д/з
                if (isStudent && (block === null || block === void 0 ? void 0 : block.style) === 'course_homework') {
                    return false;
                }
                //не показываем шаблон д/з студентам, которые отправили д/з
                if (isStudent && hasStudentWork && block.style === 'homework_student') {
                    // Если это мультиформатная домашка, не скрываем блок
                    var maxCount = (_c = (_b = block.additionalInfo) === null || _b === void 0 ? void 0 : _b.find(function (i) { return i.name === 'maxCount'; })) === null || _c === void 0 ? void 0 : _c.value;
                    var isMulti = Number(maxCount) > 1;
                    if (isMulti && Number(maxCount) > uploadedHomeworksCount) {
                        return true;
                    }
                    return false;
                }
                //не показываем преподу шаблон д/з
                if (isTeacher && (block.style === 'homework_student' || ((_d = block === null || block === void 0 ? void 0 : block.additionalInfo) === null || _d === void 0 ? void 0 : _d.find(function (i) { return (i === null || i === void 0 ? void 0 : i.name) === 'student_id'; })))) {
                    return false;
                }
                //хрен знает кто ничего не видит
                if (isNone && (block.style === 'homework_student' || (block === null || block === void 0 ? void 0 : block.style) === 'course_homework' || ((_e = block === null || block === void 0 ? void 0 : block.additionalInfo) === null || _e === void 0 ? void 0 : _e.find(function (i) { return (i === null || i === void 0 ? void 0 : i.name) === 'student_id'; })))) {
                    return false;
                }
                // Проверка группы для блоков домашних заданий (только для студентов)
                if (isStudent) {
                    var blockGroupId_1 = (_g = (_f = block === null || block === void 0 ? void 0 : block.additionalInfo) === null || _f === void 0 ? void 0 : _f.find(function (i) { return (i === null || i === void 0 ? void 0 : i.name) === 'groupId'; })) === null || _g === void 0 ? void 0 : _g.value;
                    if (blockGroupId_1 && blockGroupId_1.trim() !== '') {
                        var moduleGroups = (lmsModuleInfo === null || lmsModuleInfo === void 0 ? void 0 : lmsModuleInfo.groups) || [];
                        var groupExists = moduleGroups.some(function (group) { return (group === null || group === void 0 ? void 0 : group.groupId) === blockGroupId_1; });
                        if (!groupExists) {
                            return false;
                        }
                    }
                }
                return true;
            }
            return block;
        });
    }, [props.blocks, props.isDragEnd, isTeacher, isStudent, hasStudentWork, isLMS, profileId, uploadedHomeworksCount, isNone, lmsModuleInfo]);
    var blocksSorted = useMemo(function () {
        if ((pagination === null || pagination === void 0 ? void 0 : pagination.page) > 0 && (pagination === null || pagination === void 0 ? void 0 : pagination.limit) > 0) {
            return blocksSortedRaw === null || blocksSortedRaw === void 0 ? void 0 : blocksSortedRaw.slice(((pagination === null || pagination === void 0 ? void 0 : pagination.page) - 1) * (pagination === null || pagination === void 0 ? void 0 : pagination.limit), (pagination === null || pagination === void 0 ? void 0 : pagination.page) * (pagination === null || pagination === void 0 ? void 0 : pagination.limit));
        }
        return blocksSortedRaw;
    }, [pagination, blocksSortedRaw]);
    useEffect(function () {
        var anchorMap = props.blocks.reduce(function (res, _a) {
            var anchorText = _a.anchorText, postId = _a.postId;
            if (anchorText === null || anchorText === void 0 ? void 0 : anchorText.length) {
                return __spreadArray(__spreadArray([], res, true), [
                    {
                        anchorText: anchorText,
                        postId: postId
                    }
                ], false);
            }
            return res;
        }, []);
        if (onSetAnchors) {
            onSetAnchors(anchorMap);
        }
    }, [props.blocks, onSetAnchors]);
    useEffect(function () {
        var anchorMap = props.blocks.reduce(function (res, post) {
            return __spreadArray(__spreadArray([], res, true), [
                __assign(__assign({}, post), { name: (post === null || post === void 0 ? void 0 : post.style) === 'course_homework' ? 'Домашняя работа' : post === null || post === void 0 ? void 0 : post.text })
            ], false);
        }, []);
        if (onSetThemeAnchors) {
            onSetThemeAnchors(anchorMap);
        }
    }, [props.blocks, onSetThemeAnchors]);
    /*  useEffect(() => {
        const audioMap = props.blocks.reduce((res, post) => {
          if (post?.style === 'podcast') {
            return [
              ...res,
              post
            ]
          }
          return res
        }, [])
        if (podcastProps?.onSetPlayList) {
          podcastProps.onSetPlayList(audioMap)
        }
      }, [props.blocks, podcastProps])*/
    var getVoteBlockNum = useCallback(function (index) {
        return blocksSorted === null || blocksSorted === void 0 ? void 0 : blocksSorted.reduce(function (accumulator, currentValue, currentIndex) {
            return (currentValue === null || currentValue === void 0 ? void 0 : currentValue.style) === 'super-puper-vote' && currentIndex <= index
                ? accumulator + 1
                : accumulator;
        }, 0);
    }, [blocksSorted]);
    var themeBlockIdx = useMemo(function () { var _a; return ((_a = props.blocks) === null || _a === void 0 ? void 0 : _a.length); }, [blocksSorted, props.blocks]);
    var tempBlock = useMemo(function () { var _a; return ((_a = props.blocks) === null || _a === void 0 ? void 0 : _a.find(function (i) { var _a; return (i === null || i === void 0 ? void 0 : i.style) === HOME_WORK_STUDENT_SIGN && !((_a = i === null || i === void 0 ? void 0 : i.additionalInfo) === null || _a === void 0 ? void 0 : _a.find(function (u) { return (u === null || u === void 0 ? void 0 : u.name) === 'student_id'; })); })); }, [blocksSorted, props.blocks]);
    var currentStageIdx = useMemo(function () { return blocksSorted === null || blocksSorted === void 0 ? void 0 : blocksSorted.findIndex(function (i) { return (i === null || i === void 0 ? void 0 : i.style) === 'super-puper-vote'; }); }, [blocksSorted]);
    var shouldVisibleCurrentStage = useMemo(function () {
        var _a, _b, _c;
        return (!!(blocksSorted === null || blocksSorted === void 0 ? void 0 : blocksSorted.length) &&
            ((_a = blocksSorted[0]) === null || _a === void 0 ? void 0 : _a.style) === 'colored' &&
            ((_b = blocksSorted[1]) === null || _b === void 0 ? void 0 : _b.style) === 'super-puper-vote') ||
            ((_c = blocksSorted[0]) === null || _c === void 0 ? void 0 : _c.style) === 'super-puper-vote';
    }, [blocksSorted]);
    var votesIdxs = useMemo(function () {
        if (!props.isEditable && !!(blocksSorted === null || blocksSorted === void 0 ? void 0 : blocksSorted.length)) {
            var votesBlocks = blocksSorted === null || blocksSorted === void 0 ? void 0 : blocksSorted.map(function (item, idx) {
                if ((item === null || item === void 0 ? void 0 : item.style) === 'super-puper-vote')
                    return idx;
            }).filter(function (i) { return Number(i); });
            return (votesBlocks === null || votesBlocks === void 0 ? void 0 : votesBlocks.length) > 1
                ? votesBlocks.slice(1, votesBlocks === null || votesBlocks === void 0 ? void 0 : votesBlocks.length)
                : votesBlocks;
        }
    }, [blocksSorted, props.isEditable]);
    var getVotesOffset = function (idx) { return votesIdxs === null || votesIdxs === void 0 ? void 0 : votesIdxs.includes(idx); };
    var hasExamBlock = useMemo(function () {
        return props.blocks
            ? props.blocks.some(function (block) { return block.style === 'course_exam'; })
            : false;
    }, [props.blocks]);
    var hasBibliography = useMemo(function () {
        return props.blocks
            ? props.blocks.some(function (block) { return block.style === 'bibliography'; })
            : false;
    }, [props.blocks]);
    var hasSources = useMemo(function () {
        return props.blocks
            ? props.blocks.some(function (block) { return block.style === 'image_sources'; })
            : false;
    }, [props.blocks]);
    var hasSpBlock = useMemo(function () {
        return props.blocks
            ? props.blocks.some(function (block) { return block.style === 'super-puper-vote'; })
            : false;
    });
    var listId = useMemo(function () { return blocksSorted === null || blocksSorted === void 0 ? void 0 : blocksSorted.map(function (i) { return i === null || i === void 0 ? void 0 : i.postId; }); }, [blocksSorted]);
    var count = useMemo(function () { return blocksSorted === null || blocksSorted === void 0 ? void 0 : blocksSorted.length; }, [blocksSorted]);
    var onDragStart = function () {
        setIsDragContinue(true);
    };
    var onDragEnd = function (result) {
        var _a, _b;
        setIsDragContinue(false);
        setDid('');
        if (!result.destination) {
            return;
        }
        var bIdx = blocksSorted === null || blocksSorted === void 0 ? void 0 : blocksSorted.findIndex(function (i) { return (i === null || i === void 0 ? void 0 : i.style) === 'bibliography'; });
        var firstCoverIdx = blocksSorted === null || blocksSorted === void 0 ? void 0 : blocksSorted.findIndex(function (i) { return (i === null || i === void 0 ? void 0 : i.style) === "as_cover"; });
        if (((_a = result.destination) === null || _a === void 0 ? void 0 : _a.index) === bIdx) {
            toasts.error(t('toasts.biblio_drag'));
            return false;
        }
        if (((_b = result.destination) === null || _b === void 0 ? void 0 : _b.index) === firstCoverIdx) {
            toasts.error(t('toasts.as_cover_drag'));
            return false;
        }
        var blocks = Reorder(props.blocks, result.source.index, result.destination.index);
        var lgid = props.lgid;
        props.longreadDragEnd(blocks);
        props.updateLongReadPosition(result.draggableId, result.destination.index - result.source.index, lgid, '2', sign);
    };
    var onBeforeCapture = function (e) {
        setDid(e.draggableId);
    };
    var onSetActiveSlideScroll = function (e) {
        var centerX = document.documentElement.clientWidth / 2;
        var centerY = document.documentElement.clientHeight / 2;
        var elem = document.elementFromPoint(centerX, centerY);
        if (elem !== null) {
            var parent_1 = elem === null || elem === void 0 ? void 0 : elem.closest('div[data-rbd-draggable-id]');
            var twoPictureBlock = parent_1 === null || parent_1 === void 0 ? void 0 : parent_1.closest('.two_pictures_block');
            //Костыль для правки бага с undefined при скроле блоков с 2 изображениями
            if (twoPictureBlock) {
                parent_1 = twoPictureBlock === null || twoPictureBlock === void 0 ? void 0 : twoPictureBlock.closest('div[data-rbd-draggable-id]');
            }
            if (parent_1) {
                var id = parent_1.getAttribute('data-rbd-draggable-id');
                props.onViewCurrentSlideScroll(id, listId, count);
            }
        }
    };
    useEffect(function () {
        if (!props.lgid)
            return;
        if (shouldHavePagination) {
            setCurrentPage(1);
            setDisplayedBlocks(pagingLimit);
            props.getLongReadPostsPaginated('2', props.lgid, sign, props.thematic, currentSorting, pagingLimit, 0, 1);
        }
        else {
            props.getLongReadPosts('2', props.lgid, sign, props.thematic, currentSorting);
        }
    }, [sign, props.lgid, props.thematic, currentSorting, shouldHavePagination, pagingLimit]);
    useEffect(function () {
        if (props.onViewCurrentSlideScroll &&
            onSetActiveSlideScroll &&
            blocksSorted &&
            listId) {
            document.addEventListener('scroll', onSetActiveSlideScroll);
            return function () {
                document.removeEventListener('scroll', onSetActiveSlideScroll);
            };
        }
    }, [
        props.onViewCurrentSlideScroll,
        onSetActiveSlideScroll,
        blocksSorted,
        listId
    ]);
    useEffect(function () {
        if (isStageChange && !isEndVote) {
            window.location.reload();
        }
    }, [isStageChange, isEndVote]);
    useEffect(function () {
        if ((votesProps === null || votesProps === void 0 ? void 0 : votesProps.entityId) !== null) {
            dispatch(setVoteEntityId(votesProps.entityId));
        }
    }, [votesProps]);
    useEffect(function () {
        if (isEndVote) {
            dispatch(setVoteWinner(isEndVote));
        }
    }, [isEndVote]);
    var shouldHavePagination = useMemo(function () {
        return !!pagingLimit && !isEditable && !isPrint;
    }, [pagingLimit, isEditable, isPrint, printType]);
    var loadMoreBlocks = useCallback(function () {
        if (isLoadingMore || !props.lgid || !shouldHavePagination)
            return;
        setIsLoadingMore(true);
        var nextPage = currentPage + 1;
        var offset = (nextPage - 1) * pagingLimit;
        props.getLongReadPostsPaginated('2', props.lgid, sign, props.thematic, currentSorting, pagingLimit, offset, nextPage);
        setTimeout(function () {
            setCurrentPage(nextPage);
            setDisplayedBlocks(displayedBlocks + pagingLimit);
            setIsLoadingMore(false);
        }, 100);
    }, [currentPage, displayedBlocks, isLoadingMore, props.lgid, sign, props.thematic, currentSorting, pagingLimit, shouldHavePagination]);
    var blocks = useMemo(function () {
        if (printType === 'magazine' && (blocksSorted === null || blocksSorted === void 0 ? void 0 : blocksSorted.length)) {
            return __spreadArray([], blocksSorted, true);
        }
        if (shouldHavePagination) {
            return blocksSorted === null || blocksSorted === void 0 ? void 0 : blocksSorted.slice(0, displayedBlocks);
        }
        return blocksSorted;
    }, [blocksSorted, displayedBlocks, shouldHavePagination, magazineContent]);
    var transformedBlocks = useMemo(function () {
        if (printType === 'magazine') {
            return magazineBlocks;
        }
        return blocks;
    }, [blocks, magazineBlocks]);
    var paginationData = useMemo(function () {
        return props.pagination || { hasMore: false, isLoading: false };
    }, [props.pagination]);
    var firstStudentPostIndex = useMemo(function () {
        if (!blocks || !isLMS)
            return -1;
        return blocks.findIndex(function (post) {
            var _a, _b;
            var isStudentPost = (((_b = (_a = post === null || post === void 0 ? void 0 : post.additionalInfo) === null || _a === void 0 ? void 0 : _a.find(function (data) { return (data === null || data === void 0 ? void 0 : data.name) === 'student_id'; })) === null || _b === void 0 ? void 0 : _b.value) || '') === profileId;
            return isStudentPost;
        });
    }, [blocks, isLMS, profileId]);
    if (!(blocks === null || blocks === void 0 ? void 0 : blocks.length)) {
        return React.createElement(FlexBox, { offsetBottom: 24 });
    }
    if (printType === 'magazine' && !(magazineBlocks === null || magazineBlocks === void 0 ? void 0 : magazineBlocks.length)) {
        return (React.createElement(MeasureTemlate, { posts: blocks, setMagazineBlocks: setMagazineBlocks }));
    }
    return (React.createElement(PostCommentProvider, null,
        React.createElement(DragDropContext, { onDragEnd: onDragEnd, onDragStart: onDragStart, onBeforeCapture: onBeforeCapture },
            React.createElement(Droppable, { droppableId: 'droppable', type: 'QUESTIONS' }, function (provided, snapshot) { return (React.createElement(Bg, __assign({ ref: provided.innerRef }, provided.droppableProps, { printType: printType }),
                React.createElement(InfiniteScroll, { style: { overflow: 'visible' }, dataLength: blocks === null || blocks === void 0 ? void 0 : blocks.length, next: loadMoreBlocks, hasMore: shouldHavePagination && (paginationData === null || paginationData === void 0 ? void 0 : paginationData.hasMore) && !isLoadingMore, loader: React.createElement("div", null, "Loading...") }, transformedBlocks === null || transformedBlocks === void 0 ? void 0 :
                    transformedBlocks.map(function (post, index) {
                        var _a, _b;
                        var isStudentPost = isLMS && (((_b = (_a = post === null || post === void 0 ? void 0 : post.additionalInfo) === null || _a === void 0 ? void 0 : _a.find(function (data) { return (data === null || data === void 0 ? void 0 : data.name) === 'student_id'; })) === null || _b === void 0 ? void 0 : _b.value) || '') === profileId;
                        var HomeWorkTitleText = getAdditionalInfoVal(post === null || post === void 0 ? void 0 : post.additionalInfo, 'text') || '';
                        var shouldShow = limitContentCount !== undefined && index === limitContentCount;
                        var shouldShowHomeworkTitle = isStudentPost && !(props === null || props === void 0 ? void 0 : props.isEditable) && index === firstStudentPostIndex;
                        setLongreadStyle && setLongreadStyle(post.style === 'image_sources' ? 'image_sources' : '');
                        return (React.createElement(React.Fragment, null,
                            shouldShow && protectInfoComponent,
                            shouldShowHomeworkTitle && React.createElement(HomeworkTitleBlock, { text: HomeWorkTitleText, colorStyle: props.colorStyle, viewType: props.viewType }),
                            React.createElement(Draggable, { key: post === null ? '0' : post === null || post === void 0 ? void 0 : post.postId, draggableId: post === null ? '0' : post === null || post === void 0 ? void 0 : post.postId, index: index, isDragDisabled: !(props === null || props === void 0 ? void 0 : props.isEditable) ||
                                    (post === null || post === void 0 ? void 0 : post.style) === 'bibliography' ||
                                    (post === null || post === void 0 ? void 0 : post.style) === 'image_sources' }, function (provided, snapshot) {
                                var _a;
                                if (post === null) {
                                    return React.createElement("div", null, "\u041D\u0435\u0442 \u043F\u043E\u0441\u0442\u043E\u0432!");
                                }
                                if (window.innerWidth < 940 &&
                                    props.updatedPost.id === post.postId &&
                                    post.style === 'normal') {
                                    return (React.createElement(BottomTextEditor, { isUpdate: true, post: post, index: index, lgid: props.lgid, colorStyle: props.colorStyle, blocksLength: props.blocksLength, mobileEditorAction: props.mobileEditorAction, toggleMobileEditor: props.toggleMobileEditor, onSetMobTextLength: props.onSetMobTextLength }));
                                }
                                if (window.innerWidth < 940 &&
                                    props.updatedPost.id === post.postId &&
                                    post.style === 'colored') {
                                    return (React.createElement(BottomTextEditor, { isUpdate: true, post: post, index: index, lgid: props.lgid, colorStyle: props.colorStyle, blocksLength: props.blocksLength, mobileEditorAction: props.mobileEditorAction, toggleMobileEditor: props.toggleMobileEditor, onSetMobTextLength: props.onSetMobTextLength }));
                                }
                                if (window.innerWidth < 940 &&
                                    ((_a = props === null || props === void 0 ? void 0 : props.updatedPost) === null || _a === void 0 ? void 0 : _a.id) === (post === null || post === void 0 ? void 0 : post.postId) &&
                                    (post === null || post === void 0 ? void 0 : post.style) === 'image') {
                                    return (React.createElement(BottomImageEditor, { isUpdate: true, post: post, index: index, lgid: props.lgid, bookId: props.bookId, colorStyle: props.colorStyle, blocksLength: props.blocksLength }));
                                }
                                if (props.updatedPost.id === (post === null || post === void 0 ? void 0 : post.postId)) {
                                    return (React.createElement(UpdateEl, { toggleMobileEditor: toggleMobileEditor, draggableProps: provided.draggableProps, dragHandleProps: provided.dragHandleProps, innerRef: provided.innerRef, theme: props.theme, projectId: props.projectId, post: post, index: index, bookId: props.bookId, typeConnection: props.typeConnection, lgid: props.lgid, maxProjects: props.maxProjects, colorStyle: props.colorStyle, blocksLength: props.blocksLength, thematic: props.thematic, appName: props.appName, viewType: props.viewType, onOpenSetProjectsModal: onOpenSetProjectsModal, includedCards: includedCards, setIncludedCards: setIncludedCards, votesContent: votesProps, isLMS: isLMS, isPresentation: props === null || props === void 0 ? void 0 : props.isPresentation, onPresentationHeaderChange: props === null || props === void 0 ? void 0 : props.onPresentationHeaderChange, editorComponent: props === null || props === void 0 ? void 0 : props.editorComponent, teamContexts: teamContexts, teamExtraFilter: teamExtraFilter, sign: sign, teamId: teamId }));
                                }
                                return (React.createElement(React.Fragment, null,
                                    React.createElement(SmallTextBlock, { title: props.title, draggableProps: provided.draggableProps, index: index, post: post, dragHandleProps: provided.dragHandleProps, innerRef: provided.innerRef, colorStyle: props.colorStyle, isDragging: snapshot.isDragging, isDragContinue: isDragContinue, did: did, isEditable: props.isEditable, linkTo: props.linkTo, onOverlayedImageClick: props.onOverlayedImageClick, blocksLength: props.blocksLength, viewType: props.viewType, theme: props.theme, thematic: props.thematic, specBlockProps: props.specBlockProps, hasBibliography: hasBibliography, hasSources: hasSources, hasSpBlock: hasSpBlock, hasExamBlock: hasExamBlock, hasSpecialSourcesBlocks: props.hasSpecialSourcesBlocks, isMobileSaved: props.mobileEditorAction, toggleMobileEditor: props.toggleMobileEditor, shouldVisibleCoverButtons: (post === null || post === void 0 ? void 0 : post.style) === 'as_cover', coverButtons: props.coverButtons, firstAsCover: (post === null || post === void 0 ? void 0 : post.style) === 'as_cover', votesPostOffset: getVotesOffset(index), votesContent: votesProps, isPresentation: props === null || props === void 0 ? void 0 : props.isPresentation, onLongreadIsReady: props === null || props === void 0 ? void 0 : props.onLongreadIsReady, editorComponent: props === null || props === void 0 ? void 0 : props.editorComponent, currentStageIdx: currentStageIdx, themeBlockIdx: themeBlockIdx, tempBlock: tempBlock, voteBlockNum: getVoteBlockNum(index), author: props.author, uploadedHomeworksCount: uploadedHomeworksCount, submitDisabled: submitDisabled, setActiveUploader: setActiveUploader }),
                                    React.createElement(CommentViewController, { post: post }),
                                    (function () {
                                        var _a, _b, _c, _d;
                                        var maxCount = (_b = (_a = post === null || post === void 0 ? void 0 : post.additionalInfo) === null || _a === void 0 ? void 0 : _a.find(function (i) { return i.name === 'maxCount'; })) === null || _b === void 0 ? void 0 : _b.value;
                                        var isMulti = Number(maxCount) > 1;
                                        if (isLMS &&
                                            !props.isEditable &&
                                            (post === null || post === void 0 ? void 0 : post.style) === 'homework_student' &&
                                            isMulti &&
                                            uploadedHomeworksCount > 0) {
                                            return (React.createElement(SubmitHomeworkButton, { moduleProjectId: (_d = (_c = post === null || post === void 0 ? void 0 : post.additionalInfo) === null || _c === void 0 ? void 0 : _c.find(function (i) { return i.name === 'projectId'; })) === null || _d === void 0 ? void 0 : _d.value, themeLongreadId: (post === null || post === void 0 ? void 0 : post.lgid) || (post === null || post === void 0 ? void 0 : post.longreadId), postId: post === null || post === void 0 ? void 0 : post.postId, disabled: submitDisabled, activeUploader: activeUploader, onClick: handleSubmitHomework }));
                                        }
                                        return null;
                                    })()));
                            })));
                    }),
                    lastLongreadBlockLink && !props.isEditable && React.createElement(CourseLinkBlock, { lastLongreadBlockLink: lastLongreadBlockLink }),
                    provided.placeholder))); }))));
}
var mapStateToProps = function (store, _a) {
    var currentId = _a.lgid;
    var newEditLongread = getCurrentLongread(store, currentId);
    var addLongread = getAddLongread(store, currentId);
    var toggleLongReadPostUpdate = getToggleLongReadPostUpdate(store, currentId);
    return {
        blocks: newEditLongread.blocks,
        updatedPost: toggleLongReadPostUpdate,
        isDragEnd: newEditLongread.isDragEnd,
        addlgpost: addLongread,
        lgInfo: store.longreadinfo.data,
        pagination: newEditLongread.pagination
    };
};
var mapDispatchToProps = function (dispatch, _a) {
    var currentId = _a.lgid;
    return {
        // setCreator: (creatorOptions) => dispatch(setCreator(creatorOptions))
        longreadDragEnd: function (blocks) { return dispatch(longreadDragEnd(blocks, currentId)); },
        getLongReadPosts: function (idUser, isLongRead, sign, thematic, rSort) {
            return dispatch(getLongReadPosts(idUser, isLongRead, sign, thematic, rSort));
        },
        getLongReadPostsPaginated: function (idUser, isLongRead, sign, thematic, rSort, limit, offset, page) {
            return dispatch(getLongReadPostsPaginated(idUser, isLongRead, sign, thematic, rSort, limit, offset, page));
        },
        updateLongReadPosition: function (id, newposition, lgid, uid, sign) {
            return dispatch(incrementLongReadPosition(id, newposition, lgid, uid, sign));
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(DndWrap);
var templateObject_1, templateObject_2;
//# sourceMappingURL=dnd.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { Component, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
// import { useSelector } from 'react-redux';
import SmallTextBlock from './smalltextblock';
import styled, { css } from 'styled-components';
import { longreadDragEnd } from '../../../actions/longreadblocks';
import { getLongReadPosts, getLongReadPostsPaginated } from '../../../actions/getLongReadPosts';
import { updateLongReadPosition } from '../../../actions/updateLongReadPosition';
import { incrementLongReadPosition } from '../../../actions/incrementLongReadPosition';
import BottomTextEditor from '../longread/editor/texteditormobile';
import BottomImageEditor from '../longread/editor/imageeditormobile';
import UpdateEl from './editor/updateel';
import { useVotesCollection } from '../../../hooks/useVoteCollection';
import { VotesProvider, useVotesContext } from '../../../contexts/VotesContext';
import { setVoteEntityId } from '../../../actions/setVoteEntityId';
import { setVoteWinner } from '../../../actions/setVoteWinner';
import { VOTE_STATUS } from './postblocks/VoteBlock/votepostwithcollect';
import useCommonProps from '../../../hooks/useCommonProps';
import { getCurrentLongread } from "../../../reducers/longreadBlocks";
import { getAddLongread } from "../../../reducers/addLongReadPost";
import { getToggleLongReadPostUpdate } from "../../../reducers/toggleLongReadPostUpdate";
import { hasCourseRole, isStudentHomeWork } from '../../../utilites/hasCourseRole';
import { CourseLinkBlock } from "./postblocks/CourseBlock/courseLinkBlock";
import { HOME_WORK_STUDENT_SIGN } from './postblocks/CourseBlock/courseHomeWork';
import { updateLongReadPost } from '../../../actions/updateLongReadPost';
import { FlexBox, useToasts } from '@brg/ui';
import useLocalization from '../../../hooks/useLocalization';
import { useGeneralProps } from '../../../hooks/useGeneralProps';
import { HomeworkTitleBlock } from './postblocks/HomeworkTitleBlock/HomeworkTitleBlock';
import { getAdditionalInfoVal } from '../../../utilites/getAdditionalInfoVal';
import { SubmitHomeworkButton } from './postblocks/CourseBlock/SubmitHomeworkButton';
import { API, Endpoints, Lang } from '@brg/api';
import { useProfile } from '@brg/auth';
import InfiniteScroll from 'react-infinite-scroll-component';
import PostCommentProvider from '../comments/provider/CommentProvider';
import CommentViewController from '../comments';
import MeasureTemlate from './postblocks/MagazineBlock/MeasureTemlate';
var Bg = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var printType = _a.printType;
    return printType === 'magazine' && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      // scale: 0.76301496887;\n      // transform-origin: left top;\n  "], ["\n      // scale: 0.76301496887;\n      // transform-origin: left top;\n  "])));
});
export var Reorder = function (list, startIndex, endIndex) {
    var result = Array.from(list);
    var removed = result.splice(startIndex, 1)[0];
    result.splice(endIndex, 0, removed);
    return result;
};
// переписанный на func
function DndWrap(props) {
    var protectInfoComponent = props.protectInfoComponent, limitContentCount = props.limitContentCount, setLongreadStyle = props.setLongreadStyle;
    var _a = useState(false), isDragContinue = _a[0], setIsDragContinue = _a[1];
    var _b = useState((props === null || props === void 0 ? void 0 : props.includedCards) || []), includedCards = _b[0], setIncludedCards = _b[1];
    var dispatch = useDispatch();
    var _c = useLocalization(), t = _c.t, language = _c.language;
    var toasts = useToasts();
    var votesCollection = useVotesCollection();
    var _d = useCommonProps(), teamContexts = _d.teamContexts, currentSorting = _d.currentSorting, teamExtraFilter = _d.teamExtraFilter, setUpdateVoteTime = _d.setUpdateVoteTime, isPrint = _d.isPrint, printType = _d.printType, pagination = _d.pagination, onSetAnchors = _d.onSetAnchors, coverContent = _d.coverContent, longreadId = _d.longreadId, toggleMobileEditor = _d.toggleMobileEditor, role = _d.role, profileId = _d.profileId, isLMS = _d.isLMS, lastLongreadBlockLink = _d.lastLongreadBlockLink, onSetThemeAnchors = _d.onSetThemeAnchors, onOpenSetProjectsModal = _d.onOpenSetProjectsModal, sign = _d.sign, teamId = _d.teamId, isEditable = _d.isEditable, pagingLimit = _d.pagingLimit, projectId = _d.projectId, magazineContent = _d.magazineContent, lmsModuleInfo = _d.lmsModuleInfo;
    var generalProps = useGeneralProps();
    var votesAutoData = useVotesContext();
    var _e = React.useState(false), submitDisabled = _e[0], setSubmitDisabled = _e[1];
    var profile = useProfile();
    var _f = useState(pagingLimit), displayedBlocks = _f[0], setDisplayedBlocks = _f[1];
    var _g = useState(false), activeUploader = _g[0], setActiveUploader = _g[1];
    var _h = useState(1), currentPage = _h[0], setCurrentPage = _h[1];
    var _j = useState(false), isLoadingMore = _j[0], setIsLoadingMore = _j[1];
    var _k = useState([]), magazineBlocks = _k[0], setMagazineBlocks = _k[1];
    var handleSubmitHomework = function (_a) {
        var moduleProjectId = _a.moduleProjectId, themeLongreadId = _a.themeLongreadId, postId = _a.postId;
        if (submitDisabled)
            return;
        API.request()
            .endpoint(Endpoints.geograffee)
            .url('/api/LMS/SubmitHomeWork')
            .body({
            moduleProjectId: moduleProjectId || projectId || '',
            themeLongreadId: themeLongreadId || '',
            postId: postId || '',
            studentId: (profile === null || profile === void 0 ? void 0 : profile.accountId) || ''
        })
            .post()
            .send()
            .then(function (r) { return setTimeout(function () {
            dispatch(getLongReadPosts('', themeLongreadId));
        }, 1000); })
            .catch(function (error) { return console.error('Request failed', error); });
    };
    useEffect(function () {
        var _a;
        (_a = props.blocks) === null || _a === void 0 ? void 0 : _a.forEach(function (post) {
            var _a, _b;
            var submitted = (_b = (_a = post === null || post === void 0 ? void 0 : post.additionalInfo) === null || _a === void 0 ? void 0 : _a.find(function (i) { return i.name === 'is_submitted'; })) === null || _b === void 0 ? void 0 : _b.value;
            if (submitted)
                setSubmitDisabled(true);
        });
    }, [props.blocks]);
    var votesProps = useMemo(function () {
        var _a;
        return (__assign(__assign({}, props.votesContent), { voteCollectionData: (votesCollection === null || votesCollection === void 0 ? void 0 : votesCollection[0]) || [], updateVote: votesCollection === null || votesCollection === void 0 ? void 0 : votesCollection[1], entityId: (_a = votesCollection === null || votesCollection === void 0 ? void 0 : votesCollection[0]) === null || _a === void 0 ? void 0 : _a.entityId }));
    }, [votesCollection, props]);
    var isStageChange = useMemo(function () { var _a, _b; return !!((_b = (_a = votesAutoData === null || votesAutoData === void 0 ? void 0 : votesAutoData.voteData) === null || _a === void 0 ? void 0 : _a.Stages) === null || _b === void 0 ? void 0 : _b.length); }, [votesAutoData]);
    var isEndVote = useMemo(function () {
        var _a;
        return (votesProps === null || votesProps === void 0 ? void 0 : votesProps.voteCollectionData) &&
            ((_a = votesProps === null || votesProps === void 0 ? void 0 : votesProps.voteCollectionData) === null || _a === void 0 ? void 0 : _a.status) === VOTE_STATUS.end;
    }, [votesProps]);
    var hasStudentWork = useMemo(function () { var _a; return ((_a = props.blocks) === null || _a === void 0 ? void 0 : _a.some(function (p) { return isStudentHomeWork(p, profileId); })); }, [props.blocks, role]);
    var isNone = hasCourseRole('none', role);
    var isStudent = hasCourseRole('student', role);
    var isTeacher = hasCourseRole('teacher', role);
    //Сохранялка мобильной презентации
    useEffect(function () {
        if (props.isPresentation && window.innerWidth <= 940 && props.mobileEditorAction === 'savePresentation') {
            var coverPost = blocksSorted === null || blocksSorted === void 0 ? void 0 : blocksSorted.find(function (i) { return i.style === 'as_cover'; });
            dispatch(updateLongReadPost('', __assign(__assign({}, coverPost), { text: coverContent === null || coverContent === void 0 ? void 0 : coverContent.psTitleMob })));
        }
    }, [props, coverContent]);
    useEffect(function () {
        if ((votesAutoData === null || votesAutoData === void 0 ? void 0 : votesAutoData.needToStart) &&
            (votesAutoData === null || votesAutoData === void 0 ? void 0 : votesAutoData.setNeedToStart) &&
            setUpdateVoteTime) {
            votesAutoData.setNeedToStart(false);
            setUpdateVoteTime(new Date().getTime());
        }
    }, [
        votesAutoData === null || votesAutoData === void 0 ? void 0 : votesAutoData.needToStart,
        setUpdateVoteTime,
        votesAutoData === null || votesAutoData === void 0 ? void 0 : votesAutoData.setNeedToStart
    ]);
    var _l = useState(''), did = _l[0], setDid = _l[1];
    //todo объединить все переборы в один
    var uploadedHomeworksCount = useMemo(function () {
        return Array.isArray(props.blocks) && props.blocks.filter(function (block) {
            var _a;
            return ((_a = block.additionalInfo) === null || _a === void 0 ? void 0 : _a.find(function (i) { return i.name === 'hm_type'; })) &&
                (block.style !== 'homework_student' && block.style !== 'course_homework');
        }).length;
    }, [props.blocks]);
    var blocksSortedRaw = useMemo(function () {
        var _a;
        return props.isDragEnd ?
            props.blocks : (_a = __spreadArray([], props.blocks, true)) === null || _a === void 0 ? void 0 : _a.filter(function (block) {
            var _a, _b, _c, _d, _e, _f, _g;
            // на печати будут показываться не все блоки
            var printStyles = ['big', 'image', 'colored', 'normal', 'slider', 'two_pictures', 'projects', 'bibliography', 'image_sources'];
            if (isPrint)
                return printStyles.includes(block === null || block === void 0 ? void 0 : block.style);
            if (isLMS) {
                //показываем пост студента после отправки д/з
                if (isStudent && hasStudentWork && isStudentHomeWork(block, profileId)) {
                    return true;
                }
                //не показываем работы других студентов
                if (isStudent && !isStudentHomeWork(block, profileId) && ((_a = block === null || block === void 0 ? void 0 : block.additionalInfo) === null || _a === void 0 ? void 0 : _a.find(function (i) { return (i === null || i === void 0 ? void 0 : i.name) === 'student_id'; }))) {
                    return false;
                }
                //не показываем студентам блок создания нового д/з
                if (isStudent && (block === null || block === void 0 ? void 0 : block.style) === 'course_homework') {
                    return false;
                }
                //не показываем шаблон д/з студентам, которые отправили д/з
                if (isStudent && hasStudentWork && block.style === 'homework_student') {
                    // Если это мультиформатная домашка, не скрываем блок
                    var maxCount = (_c = (_b = block.additionalInfo) === null || _b === void 0 ? void 0 : _b.find(function (i) { return i.name === 'maxCount'; })) === null || _c === void 0 ? void 0 : _c.value;
                    var isMulti = Number(maxCount) > 1;
                    if (isMulti && Number(maxCount) > uploadedHomeworksCount) {
                        return true;
                    }
                    return false;
                }
                //не показываем преподу шаблон д/з
                if (isTeacher && (block.style === 'homework_student' || ((_d = block === null || block === void 0 ? void 0 : block.additionalInfo) === null || _d === void 0 ? void 0 : _d.find(function (i) { return (i === null || i === void 0 ? void 0 : i.name) === 'student_id'; })))) {
                    return false;
                }
                //хрен знает кто ничего не видит
                if (isNone && (block.style === 'homework_student' || (block === null || block === void 0 ? void 0 : block.style) === 'course_homework' || ((_e = block === null || block === void 0 ? void 0 : block.additionalInfo) === null || _e === void 0 ? void 0 : _e.find(function (i) { return (i === null || i === void 0 ? void 0 : i.name) === 'student_id'; })))) {
                    return false;
                }
                // Проверка группы для блоков домашних заданий (только для студентов)
                if (isStudent) {
                    var blockGroupId_1 = (_g = (_f = block === null || block === void 0 ? void 0 : block.additionalInfo) === null || _f === void 0 ? void 0 : _f.find(function (i) { return (i === null || i === void 0 ? void 0 : i.name) === 'groupId'; })) === null || _g === void 0 ? void 0 : _g.value;
                    if (blockGroupId_1 && blockGroupId_1.trim() !== '') {
                        var moduleGroups = (lmsModuleInfo === null || lmsModuleInfo === void 0 ? void 0 : lmsModuleInfo.groups) || [];
                        var groupExists = moduleGroups.some(function (group) { return (group === null || group === void 0 ? void 0 : group.groupId) === blockGroupId_1; });
                        if (!groupExists) {
                            return false;
                        }
                    }
                }
                return true;
            }
            return block;
        });
    }, [props.blocks, props.isDragEnd, isTeacher, isStudent, hasStudentWork, isLMS, profileId, uploadedHomeworksCount, isNone, lmsModuleInfo]);
    var blocksSorted = useMemo(function () {
        if ((pagination === null || pagination === void 0 ? void 0 : pagination.page) > 0 && (pagination === null || pagination === void 0 ? void 0 : pagination.limit) > 0) {
            return blocksSortedRaw === null || blocksSortedRaw === void 0 ? void 0 : blocksSortedRaw.slice(((pagination === null || pagination === void 0 ? void 0 : pagination.page) - 1) * (pagination === null || pagination === void 0 ? void 0 : pagination.limit), (pagination === null || pagination === void 0 ? void 0 : pagination.page) * (pagination === null || pagination === void 0 ? void 0 : pagination.limit));
        }
        return blocksSortedRaw;
    }, [pagination, blocksSortedRaw]);
    useEffect(function () {
        var anchorMap = props.blocks.reduce(function (res, _a) {
            var anchorText = _a.anchorText, postId = _a.postId;
            if (anchorText === null || anchorText === void 0 ? void 0 : anchorText.length) {
                return __spreadArray(__spreadArray([], res, true), [
                    {
                        anchorText: anchorText,
                        postId: postId
                    }
                ], false);
            }
            return res;
        }, []);
        if (onSetAnchors) {
            onSetAnchors(anchorMap);
        }
    }, [props.blocks, onSetAnchors]);
    useEffect(function () {
        var anchorMap = props.blocks.reduce(function (res, post) {
            return __spreadArray(__spreadArray([], res, true), [
                __assign(__assign({}, post), { name: (post === null || post === void 0 ? void 0 : post.style) === 'course_homework' ? 'Домашняя работа' : post === null || post === void 0 ? void 0 : post.text })
            ], false);
        }, []);
        if (onSetThemeAnchors) {
            onSetThemeAnchors(anchorMap);
        }
    }, [props.blocks, onSetThemeAnchors]);
    /*  useEffect(() => {
        const audioMap = props.blocks.reduce((res, post) => {
          if (post?.style === 'podcast') {
            return [
              ...res,
              post
            ]
          }
          return res
        }, [])
        if (podcastProps?.onSetPlayList) {
          podcastProps.onSetPlayList(audioMap)
        }
      }, [props.blocks, podcastProps])*/
    var getVoteBlockNum = useCallback(function (index) {
        return blocksSorted === null || blocksSorted === void 0 ? void 0 : blocksSorted.reduce(function (accumulator, currentValue, currentIndex) {
            return (currentValue === null || currentValue === void 0 ? void 0 : currentValue.style) === 'super-puper-vote' && currentIndex <= index
                ? accumulator + 1
                : accumulator;
        }, 0);
    }, [blocksSorted]);
    var themeBlockIdx = useMemo(function () { var _a; return ((_a = props.blocks) === null || _a === void 0 ? void 0 : _a.length); }, [blocksSorted, props.blocks]);
    var tempBlock = useMemo(function () { var _a; return ((_a = props.blocks) === null || _a === void 0 ? void 0 : _a.find(function (i) { var _a; return (i === null || i === void 0 ? void 0 : i.style) === HOME_WORK_STUDENT_SIGN && !((_a = i === null || i === void 0 ? void 0 : i.additionalInfo) === null || _a === void 0 ? void 0 : _a.find(function (u) { return (u === null || u === void 0 ? void 0 : u.name) === 'student_id'; })); })); }, [blocksSorted, props.blocks]);
    var currentStageIdx = useMemo(function () { return blocksSorted === null || blocksSorted === void 0 ? void 0 : blocksSorted.findIndex(function (i) { return (i === null || i === void 0 ? void 0 : i.style) === 'super-puper-vote'; }); }, [blocksSorted]);
    var shouldVisibleCurrentStage = useMemo(function () {
        var _a, _b, _c;
        return (!!(blocksSorted === null || blocksSorted === void 0 ? void 0 : blocksSorted.length) &&
            ((_a = blocksSorted[0]) === null || _a === void 0 ? void 0 : _a.style) === 'colored' &&
            ((_b = blocksSorted[1]) === null || _b === void 0 ? void 0 : _b.style) === 'super-puper-vote') ||
            ((_c = blocksSorted[0]) === null || _c === void 0 ? void 0 : _c.style) === 'super-puper-vote';
    }, [blocksSorted]);
    var votesIdxs = useMemo(function () {
        if (!props.isEditable && !!(blocksSorted === null || blocksSorted === void 0 ? void 0 : blocksSorted.length)) {
            var votesBlocks = blocksSorted === null || blocksSorted === void 0 ? void 0 : blocksSorted.map(function (item, idx) {
                if ((item === null || item === void 0 ? void 0 : item.style) === 'super-puper-vote')
                    return idx;
            }).filter(function (i) { return Number(i); });
            return (votesBlocks === null || votesBlocks === void 0 ? void 0 : votesBlocks.length) > 1
                ? votesBlocks.slice(1, votesBlocks === null || votesBlocks === void 0 ? void 0 : votesBlocks.length)
                : votesBlocks;
        }
    }, [blocksSorted, props.isEditable]);
    var getVotesOffset = function (idx) { return votesIdxs === null || votesIdxs === void 0 ? void 0 : votesIdxs.includes(idx); };
    var hasExamBlock = useMemo(function () {
        return props.blocks
            ? props.blocks.some(function (block) { return block.style === 'course_exam'; })
            : false;
    }, [props.blocks]);
    var hasBibliography = useMemo(function () {
        return props.blocks
            ? props.blocks.some(function (block) { return block.style === 'bibliography'; })
            : false;
    }, [props.blocks]);
    var hasSources = useMemo(function () {
        return props.blocks
            ? props.blocks.some(function (block) { return block.style === 'image_sources'; })
            : false;
    }, [props.blocks]);
    var hasSpBlock = useMemo(function () {
        return props.blocks
            ? props.blocks.some(function (block) { return block.style === 'super-puper-vote'; })
            : false;
    });
    var listId = useMemo(function () { return blocksSorted === null || blocksSorted === void 0 ? void 0 : blocksSorted.map(function (i) { return i === null || i === void 0 ? void 0 : i.postId; }); }, [blocksSorted]);
    var count = useMemo(function () { return blocksSorted === null || blocksSorted === void 0 ? void 0 : blocksSorted.length; }, [blocksSorted]);
    var onDragStart = function () {
        setIsDragContinue(true);
    };
    var onDragEnd = function (result) {
        var _a, _b;
        setIsDragContinue(false);
        setDid('');
        if (!result.destination) {
            return;
        }
        var bIdx = blocksSorted === null || blocksSorted === void 0 ? void 0 : blocksSorted.findIndex(function (i) { return (i === null || i === void 0 ? void 0 : i.style) === 'bibliography'; });
        var firstCoverIdx = blocksSorted === null || blocksSorted === void 0 ? void 0 : blocksSorted.findIndex(function (i) { return (i === null || i === void 0 ? void 0 : i.style) === "as_cover"; });
        if (((_a = result.destination) === null || _a === void 0 ? void 0 : _a.index) === bIdx) {
            toasts.error(t('toasts.biblio_drag'));
            return false;
        }
        if (((_b = result.destination) === null || _b === void 0 ? void 0 : _b.index) === firstCoverIdx) {
            toasts.error(t('toasts.as_cover_drag'));
            return false;
        }
        var blocks = Reorder(props.blocks, result.source.index, result.destination.index);
        var lgid = props.lgid;
        props.longreadDragEnd(blocks);
        props.updateLongReadPosition(result.draggableId, result.destination.index - result.source.index, lgid, '2', sign);
    };
    var onBeforeCapture = function (e) {
        setDid(e.draggableId);
    };
    var onSetActiveSlideScroll = function (e) {
        var centerX = document.documentElement.clientWidth / 2;
        var centerY = document.documentElement.clientHeight / 2;
        var elem = document.elementFromPoint(centerX, centerY);
        if (elem !== null) {
            var parent_1 = elem === null || elem === void 0 ? void 0 : elem.closest('div[data-rbd-draggable-id]');
            var twoPictureBlock = parent_1 === null || parent_1 === void 0 ? void 0 : parent_1.closest('.two_pictures_block');
            //Костыль для правки бага с undefined при скроле блоков с 2 изображениями
            if (twoPictureBlock) {
                parent_1 = twoPictureBlock === null || twoPictureBlock === void 0 ? void 0 : twoPictureBlock.closest('div[data-rbd-draggable-id]');
            }
            if (parent_1) {
                var id = parent_1.getAttribute('data-rbd-draggable-id');
                props.onViewCurrentSlideScroll(id, listId, count);
            }
        }
    };
    useEffect(function () {
        if (!props.lgid)
            return;
        if (shouldHavePagination) {
            setCurrentPage(1);
            setDisplayedBlocks(pagingLimit);
            props.getLongReadPostsPaginated('2', props.lgid, sign, props.thematic, currentSorting, pagingLimit, 0, 1);
        }
        else {
            props.getLongReadPosts('2', props.lgid, sign, props.thematic, currentSorting);
        }
    }, [sign, props.lgid, props.thematic, currentSorting, shouldHavePagination, pagingLimit]);
    useEffect(function () {
        if (props.onViewCurrentSlideScroll &&
            onSetActiveSlideScroll &&
            blocksSorted &&
            listId) {
            document.addEventListener('scroll', onSetActiveSlideScroll);
            return function () {
                document.removeEventListener('scroll', onSetActiveSlideScroll);
            };
        }
    }, [
        props.onViewCurrentSlideScroll,
        onSetActiveSlideScroll,
        blocksSorted,
        listId
    ]);
    useEffect(function () {
        if (isStageChange && !isEndVote) {
            window.location.reload();
        }
    }, [isStageChange, isEndVote]);
    useEffect(function () {
        if ((votesProps === null || votesProps === void 0 ? void 0 : votesProps.entityId) !== null) {
            dispatch(setVoteEntityId(votesProps.entityId));
        }
    }, [votesProps]);
    useEffect(function () {
        if (isEndVote) {
            dispatch(setVoteWinner(isEndVote));
        }
    }, [isEndVote]);
    var shouldHavePagination = useMemo(function () {
        return !!pagingLimit && !isEditable && !isPrint;
    }, [pagingLimit, isEditable, isPrint, printType]);
    var loadMoreBlocks = useCallback(function () {
        if (isLoadingMore || !props.lgid || !shouldHavePagination)
            return;
        setIsLoadingMore(true);
        var nextPage = currentPage + 1;
        var offset = (nextPage - 1) * pagingLimit;
        props.getLongReadPostsPaginated('2', props.lgid, sign, props.thematic, currentSorting, pagingLimit, offset, nextPage);
        setTimeout(function () {
            setCurrentPage(nextPage);
            setDisplayedBlocks(displayedBlocks + pagingLimit);
            setIsLoadingMore(false);
        }, 100);
    }, [currentPage, displayedBlocks, isLoadingMore, props.lgid, sign, props.thematic, currentSorting, pagingLimit, shouldHavePagination]);
    var blocks = useMemo(function () {
        if (printType === 'magazine' && (blocksSorted === null || blocksSorted === void 0 ? void 0 : blocksSorted.length)) {
            return __spreadArray([], blocksSorted, true);
        }
        if (shouldHavePagination) {
            return blocksSorted === null || blocksSorted === void 0 ? void 0 : blocksSorted.slice(0, displayedBlocks);
        }
        return blocksSorted;
    }, [blocksSorted, displayedBlocks, shouldHavePagination, magazineContent]);
    var transformedBlocks = useMemo(function () {
        if (printType === 'magazine') {
            return magazineBlocks;
        }
        return blocks;
    }, [blocks, magazineBlocks]);
    var paginationData = useMemo(function () {
        return props.pagination || { hasMore: false, isLoading: false };
    }, [props.pagination]);
    var firstStudentPostIndex = useMemo(function () {
        if (!blocks || !isLMS)
            return -1;
        return blocks.findIndex(function (post) {
            var _a, _b;
            var isStudentPost = (((_b = (_a = post === null || post === void 0 ? void 0 : post.additionalInfo) === null || _a === void 0 ? void 0 : _a.find(function (data) { return (data === null || data === void 0 ? void 0 : data.name) === 'student_id'; })) === null || _b === void 0 ? void 0 : _b.value) || '') === profileId;
            return isStudentPost;
        });
    }, [blocks, isLMS, profileId]);
    if (!(blocks === null || blocks === void 0 ? void 0 : blocks.length)) {
        return React.createElement(FlexBox, { offsetBottom: 24 });
    }
    if (printType === 'magazine' && !(magazineBlocks === null || magazineBlocks === void 0 ? void 0 : magazineBlocks.length)) {
        return (React.createElement(MeasureTemlate, { posts: blocks, setMagazineBlocks: setMagazineBlocks }));
    }
    return (React.createElement(PostCommentProvider, null,
        React.createElement(DragDropContext, { onDragEnd: onDragEnd, onDragStart: onDragStart, onBeforeCapture: onBeforeCapture },
            React.createElement(Droppable, { droppableId: 'droppable', type: 'QUESTIONS' }, function (provided, snapshot) { return (React.createElement(Bg, __assign({ ref: provided.innerRef }, provided.droppableProps, { printType: printType }),
                React.createElement(InfiniteScroll, { style: { overflow: 'visible' }, dataLength: blocks === null || blocks === void 0 ? void 0 : blocks.length, next: loadMoreBlocks, hasMore: shouldHavePagination && (paginationData === null || paginationData === void 0 ? void 0 : paginationData.hasMore) && !isLoadingMore, loader: React.createElement("div", null, "Loading...") }, transformedBlocks === null || transformedBlocks === void 0 ? void 0 :
                    transformedBlocks.map(function (post, index) {
                        var _a, _b;
                        var isStudentPost = isLMS && (((_b = (_a = post === null || post === void 0 ? void 0 : post.additionalInfo) === null || _a === void 0 ? void 0 : _a.find(function (data) { return (data === null || data === void 0 ? void 0 : data.name) === 'student_id'; })) === null || _b === void 0 ? void 0 : _b.value) || '') === profileId;
                        var HomeWorkTitleText = getAdditionalInfoVal(post === null || post === void 0 ? void 0 : post.additionalInfo, 'text') || '';
                        var shouldShow = limitContentCount !== undefined && index === limitContentCount;
                        var shouldShowHomeworkTitle = isStudentPost && !(props === null || props === void 0 ? void 0 : props.isEditable) && index === firstStudentPostIndex;
                        setLongreadStyle && setLongreadStyle(post.style === 'image_sources' ? 'image_sources' : '');
                        return (React.createElement(React.Fragment, null,
                            shouldShow && protectInfoComponent,
                            shouldShowHomeworkTitle && React.createElement(HomeworkTitleBlock, { text: HomeWorkTitleText, colorStyle: props.colorStyle, viewType: props.viewType }),
                            React.createElement(Draggable, { key: post === null ? '0' : post === null || post === void 0 ? void 0 : post.postId, draggableId: post === null ? '0' : post === null || post === void 0 ? void 0 : post.postId, index: index, isDragDisabled: !(props === null || props === void 0 ? void 0 : props.isEditable) ||
                                    (post === null || post === void 0 ? void 0 : post.style) === 'bibliography' ||
                                    (post === null || post === void 0 ? void 0 : post.style) === 'image_sources' }, function (provided, snapshot) {
                                var _a;
                                if (post === null) {
                                    return React.createElement("div", null, "\u041D\u0435\u0442 \u043F\u043E\u0441\u0442\u043E\u0432!");
                                }
                                if (window.innerWidth < 940 &&
                                    props.updatedPost.id === post.postId &&
                                    post.style === 'normal') {
                                    return (React.createElement(BottomTextEditor, { isUpdate: true, post: post, index: index, lgid: props.lgid, colorStyle: props.colorStyle, blocksLength: props.blocksLength, mobileEditorAction: props.mobileEditorAction, toggleMobileEditor: props.toggleMobileEditor, onSetMobTextLength: props.onSetMobTextLength }));
                                }
                                if (window.innerWidth < 940 &&
                                    props.updatedPost.id === post.postId &&
                                    post.style === 'colored') {
                                    return (React.createElement(BottomTextEditor, { isUpdate: true, post: post, index: index, lgid: props.lgid, colorStyle: props.colorStyle, blocksLength: props.blocksLength, mobileEditorAction: props.mobileEditorAction, toggleMobileEditor: props.toggleMobileEditor, onSetMobTextLength: props.onSetMobTextLength }));
                                }
                                if (window.innerWidth < 940 &&
                                    ((_a = props === null || props === void 0 ? void 0 : props.updatedPost) === null || _a === void 0 ? void 0 : _a.id) === (post === null || post === void 0 ? void 0 : post.postId) &&
                                    (post === null || post === void 0 ? void 0 : post.style) === 'image') {
                                    return (React.createElement(BottomImageEditor, { isUpdate: true, post: post, index: index, lgid: props.lgid, bookId: props.bookId, colorStyle: props.colorStyle, blocksLength: props.blocksLength }));
                                }
                                if (props.updatedPost.id === (post === null || post === void 0 ? void 0 : post.postId)) {
                                    return (React.createElement(UpdateEl, { toggleMobileEditor: toggleMobileEditor, draggableProps: provided.draggableProps, dragHandleProps: provided.dragHandleProps, innerRef: provided.innerRef, theme: props.theme, projectId: props.projectId, post: post, index: index, bookId: props.bookId, typeConnection: props.typeConnection, lgid: props.lgid, maxProjects: props.maxProjects, colorStyle: props.colorStyle, blocksLength: props.blocksLength, thematic: props.thematic, appName: props.appName, viewType: props.viewType, onOpenSetProjectsModal: onOpenSetProjectsModal, includedCards: includedCards, setIncludedCards: setIncludedCards, votesContent: votesProps, isLMS: isLMS, isPresentation: props === null || props === void 0 ? void 0 : props.isPresentation, onPresentationHeaderChange: props === null || props === void 0 ? void 0 : props.onPresentationHeaderChange, editorComponent: props === null || props === void 0 ? void 0 : props.editorComponent, teamContexts: teamContexts, teamExtraFilter: teamExtraFilter, sign: sign, teamId: teamId }));
                                }
                                return (React.createElement(React.Fragment, null,
                                    React.createElement(SmallTextBlock, { title: props.title, draggableProps: provided.draggableProps, index: index, post: post, dragHandleProps: provided.dragHandleProps, innerRef: provided.innerRef, colorStyle: props.colorStyle, isDragging: snapshot.isDragging, isDragContinue: isDragContinue, did: did, isEditable: props.isEditable, linkTo: props.linkTo, onOverlayedImageClick: props.onOverlayedImageClick, blocksLength: props.blocksLength, viewType: props.viewType, theme: props.theme, thematic: props.thematic, specBlockProps: props.specBlockProps, hasBibliography: hasBibliography, hasSources: hasSources, hasSpBlock: hasSpBlock, hasExamBlock: hasExamBlock, hasSpecialSourcesBlocks: props.hasSpecialSourcesBlocks, isMobileSaved: props.mobileEditorAction, toggleMobileEditor: props.toggleMobileEditor, shouldVisibleCoverButtons: (post === null || post === void 0 ? void 0 : post.style) === 'as_cover', coverButtons: props.coverButtons, firstAsCover: (post === null || post === void 0 ? void 0 : post.style) === 'as_cover', votesPostOffset: getVotesOffset(index), votesContent: votesProps, isPresentation: props === null || props === void 0 ? void 0 : props.isPresentation, onLongreadIsReady: props === null || props === void 0 ? void 0 : props.onLongreadIsReady, editorComponent: props === null || props === void 0 ? void 0 : props.editorComponent, currentStageIdx: currentStageIdx, themeBlockIdx: themeBlockIdx, tempBlock: tempBlock, voteBlockNum: getVoteBlockNum(index), author: props.author, uploadedHomeworksCount: uploadedHomeworksCount, submitDisabled: submitDisabled, setActiveUploader: setActiveUploader }),
                                    React.createElement(CommentViewController, { post: post }),
                                    (function () {
                                        var _a, _b, _c, _d;
                                        var maxCount = (_b = (_a = post === null || post === void 0 ? void 0 : post.additionalInfo) === null || _a === void 0 ? void 0 : _a.find(function (i) { return i.name === 'maxCount'; })) === null || _b === void 0 ? void 0 : _b.value;
                                        var isMulti = Number(maxCount) > 1;
                                        if (isLMS &&
                                            !props.isEditable &&
                                            (post === null || post === void 0 ? void 0 : post.style) === 'homework_student' &&
                                            isMulti &&
                                            uploadedHomeworksCount > 0) {
                                            return (React.createElement(SubmitHomeworkButton, { moduleProjectId: (_d = (_c = post === null || post === void 0 ? void 0 : post.additionalInfo) === null || _c === void 0 ? void 0 : _c.find(function (i) { return i.name === 'projectId'; })) === null || _d === void 0 ? void 0 : _d.value, themeLongreadId: (post === null || post === void 0 ? void 0 : post.lgid) || (post === null || post === void 0 ? void 0 : post.longreadId), postId: post === null || post === void 0 ? void 0 : post.postId, disabled: submitDisabled, activeUploader: activeUploader, onClick: handleSubmitHomework }));
                                        }
                                        return null;
                                    })()));
                            })));
                    }),
                    lastLongreadBlockLink && !props.isEditable && React.createElement(CourseLinkBlock, { lastLongreadBlockLink: lastLongreadBlockLink }),
                    provided.placeholder))); }))));
}
var mapStateToProps = function (store, _a) {
    var currentId = _a.lgid;
    var newEditLongread = getCurrentLongread(store, currentId);
    var addLongread = getAddLongread(store, currentId);
    var toggleLongReadPostUpdate = getToggleLongReadPostUpdate(store, currentId);
    return {
        blocks: newEditLongread.blocks,
        updatedPost: toggleLongReadPostUpdate,
        isDragEnd: newEditLongread.isDragEnd,
        addlgpost: addLongread,
        lgInfo: store.longreadinfo.data,
        pagination: newEditLongread.pagination
    };
};
var mapDispatchToProps = function (dispatch, _a) {
    var currentId = _a.lgid;
    return {
        // setCreator: (creatorOptions) => dispatch(setCreator(creatorOptions))
        longreadDragEnd: function (blocks) { return dispatch(longreadDragEnd(blocks, currentId)); },
        getLongReadPosts: function (idUser, isLongRead, sign, thematic, rSort) {
            return dispatch(getLongReadPosts(idUser, isLongRead, sign, thematic, rSort));
        },
        getLongReadPostsPaginated: function (idUser, isLongRead, sign, thematic, rSort, limit, offset, page) {
            return dispatch(getLongReadPostsPaginated(idUser, isLongRead, sign, thematic, rSort, limit, offset, page));
        },
        updateLongReadPosition: function (id, newposition, lgid, uid, sign) {
            return dispatch(incrementLongReadPosition(id, newposition, lgid, uid, sign));
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(DndWrap);
var templateObject_1, templateObject_2;
//# sourceMappingURL=dnd.js.map